import { analytics } from "utils/firebase/firebase"
import { logEvent } from "firebase/analytics"

export namespace logAnalytics {
  export const logEvents = async (data: any) => {
    //console.log(data)
    logEvent(analytics, (data?.eventName?data.eventName:null),data?.properties?data.properties:null)    
  }
}
